// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type { CubeDimensionEntry, CubeJoinEntry } from 'shared/src/api/cube-api-types';

export const lineItemMediaTradersCubeMeta = {
  name: 'line_item_media_traders',
  sqlTable: 'metrics.line_item_media_traders',
  title: 'Line Item Media Traders',
  description:
    "One row per (line item × assigned media trader). Group line_items measures by media_trader_name to break them down per individual trader; via line_items' joins this rolls up to campaigns/strategies. Fan-out: a line item with multiple traders counts toward each, so additive measures overlap across trader groups — never sum per-trader rows into a grand total (use an un-grouped line_items query). Ratio measures (margin, pacing) are exact within each group. To merely filter to one trader, use a 'contains' filter on line_items.media_trader_ids instead.",
  joins: {
    line_items: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry
  },
  measures: {},
  dimensions: {
    'line_item_media_traders.id': {
      sql: 'id',
      type: 'string',
      title: 'Id',
      description: 'Internal composite primary key (line_item_id + trader id). Not for grouping.',
      primaryKey: true,
      meta: {
        filter_only: true,
        short_description: 'Internal composite key (line_item_id + trader id)',
        source_tables: ['metrics.line_item_media_traders']
      }
    } as const satisfies CubeDimensionEntry,
    'line_item_media_traders.line_item_id': {
      sql: 'line_item_id',
      type: 'string',
      title: 'Line Item ID',
      description: 'Parent line item identifier (join key to line_items).',
      meta: {
        filter_only: true,
        short_description: 'Parent line item identifier (join key to line_items)',
        source_tables: ['metrics.line_item_media_traders']
      }
    } as const satisfies CubeDimensionEntry,
    'line_item_media_traders.media_trader_id': {
      sql: 'media_trader_id',
      type: 'string',
      title: 'Media Trader ID',
      description: 'User ID (UUID) of the assigned media trader.',
      meta: {
        short_description: 'User ID (UUID) of the assigned media trader',
        source_tables: ['metrics.line_item_media_traders']
      }
    } as const satisfies CubeDimensionEntry,
    'line_item_media_traders.media_trader_name': {
      sql: 'media_trader_name',
      type: 'string',
      title: 'Media Trader',
      description:
        "Individual assigned media trader. Group by this to roll up line_items measures per trader (a multi-trader line item counts toward each trader — don't sum groups into a grand total).",
      meta: {
        short_description:
          'Assigned media trader name — group by this for per-trader rollups (a multi-trader line item counts toward each)',
        source_tables: ['metrics.line_item_media_traders']
      }
    } as const satisfies CubeDimensionEntry,
    'line_item_media_traders.media_trader_email': {
      sql: 'media_trader_email',
      type: 'string',
      title: 'Media Trader Email',
      description: 'Email of the assigned media trader.',
      meta: {
        short_description: 'Email of the assigned media trader',
        source_tables: ['metrics.line_item_media_traders']
      }
    } as const satisfies CubeDimensionEntry
  }
};
